import styled from "styled-components";

interface PointBoxProps {
  $type: "ADD" | "USE";
}

export const PointHistoryItem = styled.li`
  display: flex;
  width: 100%;
  height: 90px;
  padding: 0 16px;
  align-items: center;
  justify-content: space-between;
  flex-shrink: 0;
`;

export const PointHistroyTit = styled.div`
  display: flex;
  color: ${(props) => props.theme.colors.text4};
  font-size: 1.6rem;
  font-weight: 700;
  flex-direction: column;
  gap: 6px;

  span {
    color: ${(props) => props.theme.colors.text2};
    font-size: 1.2rem;
    font-weight: 400;
  }
`;

export const PointBox = styled.div<PointBoxProps>`
  display: flex;
  color: ${(props) =>
    props.$type === "ADD"
      ? props.theme.colors.primary100
      : props.theme.colors.red100};
  font-size: 1.6rem;
  font-weight: 800;
  align-items: center;
  gap: 4px;
`;
